export type ModalState = {
  isOpenUploadCSVModal: boolean;
  isOpenTemplateDetectionModal: boolean;
};

export enum MODAL_ACTION {
  TOGGLE_UPLOAD_CSV_MODAL = 'TOGGLE_UPLOAD_CSV_MODAL',
  TOGGLE_TEMPLATE_DETECTION_MODAL = 'TOGGLE_TEMPLATE_DETECTION_MODAL',
}

export type ModalAction = {
  type: MODAL_ACTION;
};

export function modalReducer(
  state: ModalState,
  action: ModalAction,
): ModalState {
  switch (action.type) {
    case MODAL_ACTION.TOGGLE_UPLOAD_CSV_MODAL:
      return {
        ...state,
        isOpenUploadCSVModal: !state.isOpenUploadCSVModal,
      };
    case MODAL_ACTION.TOGGLE_TEMPLATE_DETECTION_MODAL:
      return {
        ...state,
        isOpenTemplateDetectionModal: !state.isOpenTemplateDetectionModal,
      };
    default:
      return state;
  }
}
